import { Box } from 'components/Material/Box'
import IconButton from 'components/Material/IconButton'
import TrashCan from 'assets/icons/TrashCan'
import colors from 'colors'
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import { DocumentApprovalType } from 'types/documentos'

type DocumentActionsProps = {
  document: DocumentApprovalType
  handleUploadFile: (document: DocumentApprovalType) => void
  handleDownloadFile: (document: DocumentApprovalType) => void
  handlerDelete: (document: DocumentApprovalType) => void
  checkIfDocumentToDelete: (id: number) => boolean
  proposalStatus?: string
}

const DocumentActions = ({
  proposalStatus,
  document,
  handleUploadFile,
  handleDownloadFile,
  handlerDelete,
  checkIfDocumentToDelete
}: DocumentActionsProps) => {
  const isAprovado = proposalStatus === 'A'
  const colorIcon = isAprovado ? colors['gray-cac'] : colors['blue-bb']
  return (
    <Box className="flex gap-5">
      {document.id_corcc080 === 0 || checkIfDocumentToDelete(document.id_corcc080) ? (
        <IconButton onClick={() => handleUploadFile(document)}>
          <FileUploadOutlinedIcon className="text-blue-bb" />
        </IconButton>
      ) : (
        <>
          <IconButton onClick={() => handleDownloadFile(document)}>
            <FileDownloadOutlinedIcon className="text-blue-bb" />
          </IconButton>
          <IconButton onClick={() => handlerDelete(document)} disabled={isAprovado}>
            <TrashCan colors={colorIcon} />
          </IconButton>
        </>
      )}
    </Box>
  )
}

export default DocumentActions
